



































































































import { Component, Vue } from "vue-property-decorator";
import AppHeaderFake from "@/components/AppHeaderFake.vue";
import AppHeaderProfile from "@/components/AppHeaderProfile.vue";
import { ServiceTaskType } from "@/servicetask/api/service-tasks-api";
import VBrand from "@/components/v2/V-Brand.vue";

@Component({
  components: {
    VBrand,
    AppHeaderProfile,
    AppHeaderFake
  }
})
export default class AppHeader extends Vue {
  get profile() {
    return {
      icon: this.user.icon,
      name: this.user.name,
      serviceName: this.service.name
    };
  }

  // 外から与える
  get user() {
    return this.$store.getters.user;
  }

  get service() {
    return this.$store.state.service;
  }

  get assignedProjects() {
    return this.$store.state.assignedProjects.length;
  }

  get isSelectedService(): boolean {
    return this.service.id;
  }

  get serviceTaskTypes(): ServiceTaskType[] {
    return this.$store.state.serviceTaskTypes;
  }

  get serviceChartAvailable(): boolean {
    // 作業者は対象の工程表があったら有効
    return (
      (!this.service.id || this.service.serviceChart) &&
      this.serviceTaskTypes.length > 0
    );
  }
}
